export default {
  title: 'Attributs diététiques',
};
